import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-customer-provider-izs-info',
  templateUrl: './provider-izs-info.component.html',
})
export class BaseCustomerProviderIzsInfoComponent {
  @Input() pdlId: string | undefined;
}
